export const cufrontIcons = {
  appointmentActive:
    "https://cufront-assets.s3.amazonaws.com/icons+/appointment+active.svg",
  appointmentInactive:
    "https://cufront-assets.s3.amazonaws.com/icons+/appointment+inactive.svg",
  chatActive: "https://cufront-assets.s3.amazonaws.com/icons+/chat+active.svg",
  chatInactive:
    "https://cufront-assets.s3.amazonaws.com/icons+/chat+inactive.svg",
  consultationActive:
    "https://cufront-assets.s3.amazonaws.com/icons+/consultation+active.svg",
  consultationInactive:
    "https://cufront-assets.s3.amazonaws.com/icons+/consultation+inactive.svg",
  dashboardActive:
    "https://cufront-assets.s3.amazonaws.com/icons+/dashboard+active.svg",
  dashboardInactive:
    "https://cufront-assets.s3.amazonaws.com/icons+/dashboard+inactive.svg",
  notificationActive:
    "https://cufront-assets.s3.amazonaws.com/icons+/notifications+active.svg",
  notificationInactive:
    "https://cufront-assets.s3.amazonaws.com/icons+/notifications+inactive.svg",
  settingsActive:
    "https://cufront-assets.s3.amazonaws.com/icons+/settings+active.svg",
  settingsInactive:
    "https://cufront-assets.s3.amazonaws.com/icons+/settings+inactive.svg",
  setupActive:
    "https://cufront-assets.s3.amazonaws.com/icons+/setup+active.svg",
  setupInactive:
    "https://cufront-assets.s3.amazonaws.com/icons+/setup+inactive.svg",
  homeActive: "https://cufront-assets.s3.amazonaws.com/icons+/home+active.png",
  homeInactive:
    "https://cufront-assets.s3.amazonaws.com/icons+/home+inactive.png",
  medRecordActive:
    "https://cufront-assets.s3.amazonaws.com/icons+/med+records+active.png",
  medRecordInactive:
    "https://cufront-assets.s3.amazonaws.com/icons+/med+records+inactive.png",
  profileActive:
    "https://cufront-assets.s3.amazonaws.com/icons+/profile+active.png",
  profileInactive:
    "https://cufront-assets.s3.amazonaws.com/icons+/profile+inactive.png",
  callActive: "https://cufront-assets.s3.amazonaws.com/icons+/call+active.png",
  callInactive:
    "https://cufront-assets.s3.amazonaws.com/icons+/call+inactive.png",
  notificationsActive:
    "https://cufront-assets.s3.amazonaws.com/icons+/notifications+active.png",
  notificationsInactive:
    "https://cufront-assets.s3.amazonaws.com/icons+/notifications+inactive.png",
  chatPngActive:
    "https://cufront-assets.s3.amazonaws.com/icons+/chat+active.png",
  chatPngInactive:
    "https://cufront-assets.s3.amazonaws.com/icons+/chat+inactive.png",
  logOutMobile:
    "https://cufront-assets.s3.amazonaws.com/icons+/icon-park_logout.png",
  scanner: "https://cufront-assets.s3.amazonaws.com/icons+/scanner.png",
  pin: "https://cufront-assets.s3.amazonaws.com/icons+/pin.png",
  timer: "https://cufront-assets.s3.amazonaws.com/icons+/timer.png",
  payment: "https://cufront-assets.s3.amazonaws.com/icons+/payment.png",
  cum: "https://cufront-assets.s3.amazonaws.com/icons+/cum.png",
  line: "https://cufront-assets.s3.amazonaws.com/icons+/line.png",
  customer: "https://cufront-assets.s3.amazonaws.com/icons+/customer.png",
  financeAndAccounting:
    "https://cufront-assets.s3.amazonaws.com/icons+/Mask+group+(1).png",
  financeAndAccountingInactive:
    "https://cufront-assets.s3.amazonaws.com/icons+/Frame+248.png",
  cameraIcons: "https://cufront-assets.s3.amazonaws.com/icons+/camera-icon.png",
  files: "https://cufront-assets.s3.amazonaws.com/icons+/files.png",
  gallery: "https://cufront-assets.s3.amazonaws.com/icons+/gallery.png",
  galleryImg: "https://cufront-assets.s3.amazonaws.com/gallery-img.png",
  expandSidebar:
    "https://cufront-assets.s3.amazonaws.com/icons+/mingcute_right-line.png",
  unexpandSidebar:
    "https://cufront-assets.s3.amazonaws.com/icons+/prev-icon.png",
  lineActive: "https://cufront-assets.s3.amazonaws.com/icons+/line-active.png",
  grid: "https://cufront-assets.s3.amazonaws.com/icons+/grid.png",
  // line: "https://cufront-assets.s3.amazonaws.com/icons+/lines.png",
  gridActive: "https://cufront-assets.s3.amazonaws.com/icons+/grid-active.png",
  filter: "https://cufront-assets.s3.amazonaws.com/icons+/mage_filter-fill.png",
  editPen: "https://cufront-assets.s3.amazonaws.com/icons+/edit-pen.png",
  documentIcon: "https://cufront-assets.s3.amazonaws.com/icons+/file-img.png",
  delete: "https://cufront-assets.s3.amazonaws.com/icons+/delete.png",
  edit: "https://cufront-assets.s3.amazonaws.com/icons+/edit.png",
  callIcon: "https://cufront-assets.s3.amazonaws.com/images/Frame+449.png",
  rightArrow: "https://cufront-assets.s3.amazonaws.com/images/right-arrow.png",
};

export const Appointment_Icons = {
  O: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+166+%281%29.png",
  N: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+166+%282%29.png",
  NF: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+166+%283%29.png",
  OF: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+166+%284%29.png",
  Search: "https://cufront-assets.s3.amazonaws.com/icons+/Vector+%281%29.png",
  BookAppointment:
    "https://cufront-assets.s3.amazonaws.com/icons+/Mask+group.png",
  NoShow: "https://cufront-assets.s3.amazonaws.com/icons+/no-show.png",
  blocked: "https://cufront-assets.s3.amazonaws.com/icons+/blocked.png",
  continue_consultation:
    "https://cufront-assets.s3.amazonaws.com/icons+/continue_consultation.png",
  invoice: "https://cufront-assets.s3.amazonaws.com/icons+/invoice.png",
  book_appointment:
    "https://cufront-assets.s3.amazonaws.com/icons+/book_appointment.png",
  unblock: "https://cufront-assets.s3.amazonaws.com/icons+/unblocked.png",
  restart_consultation:
    "https://cufront-assets.s3.amazonaws.com/icons+/Vector+(3).png",
};

export const Chat_Icons = {
  call: "https://cufront-assets.s3.amazonaws.com/icons+/assets/call.png",
  forward: "https://cufront-assets.s3.amazonaws.com/icons+/assets/forward.png",
  pin: "https://cufront-assets.s3.amazonaws.com/icons+/assets/pin.png",
  ion_arrow_back:
    "https://cufront-assets.s3.amazonaws.com/icons+/assets/ion_arrow-back.png",
  plus: "https://cufront-assets.s3.amazonaws.com/icons+/assets/plus.png",
  prescribe:
    "https://cufront-assets.s3.amazonaws.com/icons+/assets/prescribe.png",
  search: "https://cufront-assets.s3.amazonaws.com/icons+/assets/search.png",
  send: "https://cufront-assets.s3.amazonaws.com/icons+/assets/send.png",
  tv: "https://cufront-assets.s3.amazonaws.com/icons+/assets/tv.png",
  threeDot:
    "https://cufront-assets.s3.amazonaws.com/icons+/assets/threeDot.png",
};

export const SEARCH_ICON = `https://cufront-assets.s3.amazonaws.com/icons+/majesticons_search-line.png`;
export const COPY_ICON = `https://cufront-assets.s3.amazonaws.com/icons+/Frame+286.png`;
export const ADD_ICON = `https://cufront-assets.s3.amazonaws.com/icons+/ic_baseline-add.png`;
export const EDIT_ICON = `https://cufront-assets.s3.amazonaws.com/icons+/Frame+287.png`;
export const VIEW_ICON = `https://cufront-assets.s3.amazonaws.com/icons+/Frame+285.png`;
export const CLOSE_ICON = `https://cufront-assets.s3.amazonaws.com/icons+/basil_cross-solid.png`;
export const RED_CLOSE_ICON = `https://cufront-assets.s3.amazonaws.com/icons+/Frame+74.png`;

export const CONSULTATION_ICONS = {
  first: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+457.png",
  second:
    "https://cufront-assets.s3.amazonaws.com/icons+/profile+active+(1).png",
  third: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+458.png",
  fourth: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+241.png",
  fifth: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+486.png",
  sixth: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+487.png",
  seven: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+488.png",
  eaight: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+489.png",
  nine: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+490.png",
  ten: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+491.png",
  eleven: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+492.png",
  twelve: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+493.png",
  end_consultation:
    "https://cufront-assets.s3.amazonaws.com/icons+/Frame+172.png",
  share: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+171.png",
  save: "https://cufront-assets.s3.amazonaws.com/icons+/Vector+(6).png",
  print: "https://cufront-assets.s3.amazonaws.com/icons+/Vector+(5).png",
  expand:
    "https://cufront-assets.s3.amazonaws.com/icons+/ph_caret-right-bold.png",
  createGrp: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+412.png",
  viewGrps: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+413.png",
  reverse: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+414.png",
  ADD_MEDICINE: "https://cufront-assets.s3.amazonaws.com/icons+/Vector+(8).png",
  DELETE_MEDICINE:
    "https://cufront-assets.s3.amazonaws.com/icons+/Vector+(7).png",
  PREV: "https://cufront-assets.s3.amazonaws.com/icons+/Group.png",
  sidebarExpand:
    "https://cufront-assets.s3.amazonaws.com/icons+/ph_caret-right-bold+(1).png",
  callIcon: "https://cufront-assets.s3.amazonaws.com/images/Frame+449.png",
};

export const SETUP_ICONS = {
  dr_clinic: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+186.png",
  consultation: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+195.png",
  medicine: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+187.png",
  language: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+188.png",
  template: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+189.png",
  consultation_master:
    "https://cufront-assets.s3.amazonaws.com/icons+/Vector+(10).png",
  header_and_footer:
    "https://cufront-assets.s3.amazonaws.com/icons+/Frame+190.png",
  tv_view: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+191.png",
  billing: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+192.png",
  group: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+193.png",
  customer: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+244.png",
  service: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+245.png",
  general: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+288.png",
  ipd: "https://cufront-assets.s3.us-east-1.amazonaws.com/cure.png",
  pharmacy:
    "https://cufront-assets.s3.us-east-1.amazonaws.com/pharmacy_setup.png",
  warehouse: "https://cufront-assets.s3.us-east-1.amazonaws.com/warehouse.png",
  workflow: "https://cufront-assets.s3.us-east-1.amazonaws.com/workflow.png",
  preconsultation:
    "https://cufront-assets.s3.us-east-1.amazonaws.com/doctor-consultation.png",
  unitofMeasure:
    "https://cufront-assets.s3.us-east-1.amazonaws.com/measuring-cup.png",
  medicineSchedule:
    "https://cufront-assets.s3.us-east-1.amazonaws.com/information.png",
  pharmacy_linked_doctor:
    "https://cufront-assets.s3.us-east-1.amazonaws.com/doctor.png",
  ward_management: "https://cufront-assets.s3.us-east-1.amazonaws.com/bed.png",
};

export const doctorimage =
  "https://s3-alpha-sig.figma.com/img/5558/c498/958013de7f9b05e1cbee4be800524025?Expires=1710720000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=IB073bIQf3dh~eZ887Gb5VorXKmuktZIInAb~-bB5NMEjoUkAk~BNMmuvuysgW-620Vx34xxRA20otMsYxIeSIgPjcbfxJdJ4qKaTIh19gtMPFE9luKzACA5ljgFWE7mgurUhxFbItS2jzGEB~EDSULeiADhymhq7qEhWYDypTX7TXA8byIcMmtPcZxIqqhrBC3oFKlJlR2u9TGY~7cBLQlgikR2BJ9vZLlrwm2Fsa0oCZfTz9Tvm2usZZnPErWttVDLOxlZaT2kZRr~LnbudNHFwRR6x6AhLbn62AwdkteGZ2zqnyhcPJn3oMXs0xb04ysXxF48eP-uqkWugugvZA__";
